import { computed, onBeforeUnmount, onMounted, ref } from 'vue';

// Matches Vuetify's xs threshold.
export const MOBILE_BREAKPOINT = 600;

// Not $vuetify.breakpoint: that also looks at window.innerWidth, which grows
// when a phone browser zooms out to fit overflowing content - flipping dialogs
// back to the desktop layout. clientWidth stays at the device width.
export const getViewportWidth = (): number => document.documentElement.clientWidth;

export const useIsMobile = () => {
  const viewportWidth = ref(getViewportWidth());

  const updateViewportWidth = () => {
    viewportWidth.value = getViewportWidth();
  };

  onMounted(() => {
    window.addEventListener('resize', updateViewportWidth);
  });

  onBeforeUnmount(() => {
    window.removeEventListener('resize', updateViewportWidth);
  });

  const isMobile = computed(() => viewportWidth.value < MOBILE_BREAKPOINT);

  return { isMobile };
};
